// src/plugins/persistedState.js
export function createPersistedState(opts = {}) {
  const key = opts.key || 'vuex';
  const paths = Array.isArray(opts.paths) ? opts.paths : [];
  const storage =
    typeof window !== 'undefined'
      ? (opts.storage || window.localStorage)
      : null;
  const filter = typeof opts.filter === 'function' ? opts.filter : () => true;

  // --- utils ---
  const getByPath = (obj, path) =>
    path.split('.').reduce((o, k) => (o ? o[k] : undefined), obj);

  const setByPath = (obj, path, value) => {
    const keys = path.split('.');
    const last = keys.pop();
    let cur = obj;
    keys.forEach(k => {
      if (cur[k] == null || typeof cur[k] !== 'object') cur[k] = {};
      cur = cur[k];
    });
    cur[last] = value;
  };

  const pickPaths = (state, keep) => {
    if (!keep.length) return state;
    const out = {};
    keep.forEach(p => {
      const v = getByPath(state, p);
      if (v !== undefined) setByPath(out, p, v);
    });
    return out;
  };

  const mergeDeep = (target, source) => {
    if (typeof source !== 'object' || source === null) return target;
    Object.keys(source).forEach(k => {
      const sv = source[k];
      if (sv && typeof sv === 'object' && !Array.isArray(sv)) {
        if (!target[k] || typeof target[k] !== 'object') target[k] = {};
        mergeDeep(target[k], sv);
      } else {
        target[k] = sv;
      }
    });
    return target;
  };

  // --- plugin ---
  return store => {
    // 1) rehydrate
    if (storage) {
      try {
        const raw = storage.getItem(key);
        if (raw) {
          const saved = JSON.parse(raw);
          const nextState = mergeDeep({ ...store.state }, saved);
          store.replaceState(nextState);
        }
      } catch (e) {
        try { storage.removeItem(key); } catch (_) {}
      }
    }

    // 2) persist on mutations
    store.subscribe((mutation, state) => {
      if (!storage) return;
      if (!filter(mutation, state)) return;
      try {
        const subset = pickPaths(state, paths);
        storage.setItem(key, JSON.stringify(subset));
      } catch (e) {
        // игнорируем ошибки (квота, приватный режим и т.п.)
      }
    });
  };
}
